import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Mysqltemplate from "../../component/course/mysql";

export default class Mysqlinbangalore extends Component {
 
  render() {
  
    const title = "MySQL"
    const url= "mysql"
     const url1 ="-training-in-bangalore"
    const location = "bangalore" 
    const location1="Training in Bangalore"
     return(
      <>
          <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
            description={`Accelerate your career growth with Learnsoft's MySQL ${location1}. Our expert trainers provide you with in-depth knowledge and hands-on experience.`}
            url={`${location}/${url}${url1}`}
            img={`course/${url}.webp`}
             keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
         <Layout navbarBackgroundColor="#281E1E">
          <Mysqltemplate url1={url1} url={url} title={title} relatedlocation={location} location={location} location1={location1} />
        </Layout>
      </>
    );
  }
}
